<template>
    <div class="c-o-login-form" @keyup.enter="send()">
        <div class="c-o-login-form__inner">
            <div class="c-o-login-form__message" v-if="errorMessages.length > 0">
                    <message type="error">
                        <div class="o-wysiwyg">
                            <ul>
                                <li v-for="(message, index) in errorMessages" :key="`message-${index}`">{{message}}</li>
                            </ul>
                        </div>
                    </message>
            </div>
            <div class="c-o-login-form__message" v-else-if="sendState == 'success'">
                <message type="success">
                    <p>{{successMessage}}</p>
                </message>
            </div>
            <h1>Glömt lösenordet?</h1>
            <p>Om du har glömt ditt lösenord kan du få det skickat till dig via e-post.</p><p>Fyll i formuläret nedan så löser vi resten.</p>
            <input-email
                :icon="'person'"
                :id="677"
                :label="'E-post'"
                :placeholder="'Ex. kalle@brabyggare.se'"
                class="c-o-login-form__username"
                :class="{'c-o-login-form__inner--invalid-animation': errors.email}"
                v-model="email"
                :invalid="errors.email">
            </input-email>
            <success-button
                class="c-a-button-theme-primary c-o-login-form__submit"
                :currentState="sendState"
                @buttonClicked="send"
                :customStates="states">
            </success-button>
            <router-link to="/logga-in" class="c-o-login-form__link">Ville du logga in istället?</router-link>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import { SEND_PASSWORD, GET_ERROR } from '../../../store/store-models/forgotten-password-model';

    import { setErrors, hasErrors, isEmailValid } from '../../../helpers/error-validation';
    import { timeout } from '../../../helpers';

    import InputEmail from '../../components/atoms/form/AtomInputEmail.vue';
    import Icon from '../../components/atoms/AtomIcon.vue';
    import Message from '../../components/molecules/MoleculeMessage.vue';
    import SuccessButton from '../../components/atoms/AtomSuccessButton.vue';


    export default {
        components: {
            InputEmail,
            Icon,
            Message,
            SuccessButton
        },
        data() {
            return {
                email: '',
                errorMessages: [],
                successMessage: 'Ditt lösenord har skickats!',
                errors: {
                    email: false
                },
                states: {
                    default: {
                        label: 'Skicka',
                    },
                    processing: {
                        label: 'Skickar',
                    },
                    success: {
                        label: 'Skickat!',
                    },
                    error: {
                        label: 'Fel!',
                    }
                },
                sendState: 'default'
            }
        },
        computed: {
            ...mapGetters({
                getError: GET_ERROR,
            })
        },
        methods: {
            ...mapActions({
                sendPassword: SEND_PASSWORD
            }),
            async send() {
                this.errorMessages = [];
                setErrors(this.errors, ['email'], false);

                if(!this.email) {
                    this.errorMessages.push('Fylll i det rödmarkerade fältet');
                    setErrors(this.errors, ['email'], true);
                }

                if( !isEmailValid(this.email) ) {
                    this.errorMessages.push('Fyll i en korrekt mejladress');
                    setErrors(this.errors, ['email'], true);
                }

                if( hasErrors(this.errors, ['email']) ) {
                    this.sendState = 'error';
                    return;
                }

                const formData = { "Email": this.email };
                this.sendState = 'processing';

                try {
                    await this.sendPassword(formData);
                    this.sendState = 'success';
                } catch (error) {
                    this.errorMessages.push(this.getError);
                    this.sendState = 'error';
                }

                await timeout();
                this.sendState = 'default';
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismForgottenPasswordForm.vue